import { render } from "./AddEditContract.vue?vue&type=template&id=23ced514"
import script from "./AddEditContract.vue?vue&type=script&lang=js"
export * from "./AddEditContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__